<template>
    <div
        class="m-tabs"
        :class="{'m-tabs--center':center}"
    >
        <a-button
            v-for="item in items"
            v-bind:key="item.id"
            class="m-tabs__tab"
            :class="{'a-button--grey':item.id != selected && item.value !== selected, 'm-tabs__tab--wide': wide}"
            @click="emit(item)"
        >
            {{ item.label || item.name }}
        </a-button>
    </div>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            required: true
        },
        selected: {
            required: true
        },
        center: {
            type: Boolean,
            default: false
        },
        wide: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        emit(item) {
            this.$emit('input', item)
            this.current = item
        }
    },
    mounted() {
        this.$emit('firstItem', this.items[0])
    }
}
</script>